import { UpdateCustomerSettingsSchema } from './schema';
import type { UpdateCustomerSettings } from './schema';
import { HTTP_METHOD } from '../../consts';
import { serializeRequestBody } from '../../serializer';
import type { Transport, ApiCallOptions } from '../../types';

export const createCustomerApi = (transport: Transport) => ({
  updateCustomer: (data: UpdateCustomerSettings, options?: ApiCallOptions) =>
    transport('manage/v1/account-details/customer', {
      method: HTTP_METHOD.PATCH,
      body: serializeRequestBody(data),
      deserializer: UpdateCustomerSettingsSchema,
      signal: options?.signal
    })
});

export type CustomerApi = ReturnType<typeof createCustomerApi>;
